import XLSX from 'xlsx';

export default function generateExcel(rows: Array<any>) {
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(rows);
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Responsabilidades');
  XLSX.writeFile(workbook, 'tabla-responsabilidad.xlsx', { compression: true });
}